































































































































































































































































































import LocationCardComponent from "./LocationCardComponent";
export default LocationCardComponent;
